export default __webpack_public_path__ + "static/og-img-1.5M-room-to-read-78aabb79df5dd9011fc6dcfa8db97228.png";